import { create } from 'zustand';

export interface Selections {
    photoOpt: string;
    photoAddons: string[];
    photoSecondCam: boolean;
    streamOpt: string;
    streamAddons: string[];
    streamSecondCam: boolean;
    videoOpt: string;
    videoEdit: string;
    videoAddons: string[];
    videoSecondCam: boolean;
    droneOpt: string;
    droneAddons: string[];
    crowd: 's' | 'm' | 'l';
    diaspora: boolean;
    transportZone: string;
    transportKm: number;
}

export interface FormState {
    firstName: string;
    lastName: string;
    whatsapp: string;
    email: string;
    relation: string;
    deceased: string;
    serviceDate: string;
    startTime: string;
    endTime: string;
    venue: string;
    venue2: string;
    keyMoments: string;
    notes: string;
    diasporaCountry: string;
    kenyaContact: string;
    refOther: string;
    consent: boolean;
}

export const INIT_SEL: Selections = {
    photoOpt: '', photoAddons: [], photoSecondCam: false,
    streamOpt: '', streamAddons: [], streamSecondCam: false,
    videoOpt: '', videoEdit: '', videoAddons: [], videoSecondCam: false,
    droneOpt: '', droneAddons: [],
    crowd: 's', diaspora: false,
    transportZone: '', transportKm: 0,
};

export const INIT_FORM: FormState = {
    firstName: '', lastName: '', whatsapp: '', email: '', relation: '',
    deceased: '', serviceDate: '', startTime: '', endTime: '',
    venue: '', venue2: '', keyMoments: '', notes: '',
    diasporaCountry: '', kenyaContact: '', refOther: '', consent: false,
};

interface BookingStore {
    step: number;
    sel: Selections;
    form: FormState;
    quietDignity: boolean;
    setStep: (step: number | ((prev: number) => number)) => void;
    updateSel: (patch: Partial<Selections>) => void;
    updateForm: (patch: Partial<FormState>) => void;
    toggleQuietDignity: () => void;
    resetAll: () => void;
}

export const useBookingStore = create<BookingStore>((set) => ({
    step: 1,
    sel: INIT_SEL,
    form: INIT_FORM,
    quietDignity: false,

    setStep: (stepOrUpdater) =>
        set((state) => ({
            step: typeof stepOrUpdater === 'function' ? stepOrUpdater(state.step) : stepOrUpdater,
        })),

    updateSel: (patch) =>
        set((state) => ({
            sel: { ...state.sel, ...patch },
        })),

    updateForm: (patch) =>
        set((state) => ({
            form: { ...state.form, ...patch },
        })),

    toggleQuietDignity: () =>
        set((state) => ({
            quietDignity: !state.quietDignity,
        })),

    resetAll: () =>
        set({
            step: 1,
            sel: INIT_SEL,
            form: INIT_FORM,
            quietDignity: false,
        }),
}));
